import { TELEGRAM_BOT_USERNAME } from './constants.js';

let telegramOverlay = null;

export function ensureTelegramOverlay() {
  if (telegramOverlay) {
    return telegramOverlay;
  }
  telegramOverlay = document.createElement('div');
  telegramOverlay.id = 'telegram-overlay';
  telegramOverlay.style.cssText = 'position:fixed; inset:0; display:none; align-items:center; justify-content:center; background:rgba(17,24,39,0.92); color:#f9fafb; z-index:9999; padding:24px; text-align:center; font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;';
  telegramOverlay.innerHTML = '<div id="telegram-overlay-content"></div>';
  document.body.appendChild(telegramOverlay);
  return telegramOverlay;
}

export function showTelegramOverlay(message, showBotButton = true, titleOverride = null) {
  const overlay = ensureTelegramOverlay();
  const content = overlay.querySelector('#telegram-overlay-content');
  const title = titleOverride || (showBotButton ? 'Откройте приложение через Telegram' : 'Подключаемся к Telegram...');
  const buttonHtml = showBotButton
    ? `<a href="https://t.me/${TELEGRAM_BOT_USERNAME}" style="display:inline-flex;align-items:center;gap:8px;background:#2563eb;color:#f9fafb;padding:12px 20px;border-radius:999px;font-weight:600;text-decoration:none;margin-top:20px;">Открыть бот @${TELEGRAM_BOT_USERNAME}</a>`
    : '';
  content.innerHTML = `
    <div style="font-size:56px;margin-bottom:16px;">🤖</div>
    <h1 style="margin-bottom:12px;font-size:24px;">${title}</h1>
    <p style="margin:0 auto;max-width:320px;font-size:16px;line-height:1.5;color:rgba(249,250,251,0.85);">${message}</p>
    ${buttonHtml}
  `;
  overlay.style.display = 'flex';
}

export function hideTelegramOverlay() {
  // НЕ скрываем overlay если доступ запрещен
  if (window.__accessDenied) {
    console.log('[overlay] ⚠️ Attempt to hide overlay while access denied - blocked');
    return;
  }
  
  // НЕ скрываем заглушку доступа
  const accessDeniedStub = document.getElementById('access-denied-stub');
  if (accessDeniedStub && accessDeniedStub.getAttribute('data-access-denied') === 'true') {
    console.log('[overlay] ⚠️ Attempt to hide access denied stub - blocked');
    return;
  }
  
  if (!telegramOverlay) return;
  // Принудительно скрываем overlay несколькими способами для надежности
  telegramOverlay.style.display = 'none';
  telegramOverlay.style.visibility = 'hidden';
  telegramOverlay.style.opacity = '0';
  telegramOverlay.style.pointerEvents = 'none';
  // Также пробуем удалить классы, если они есть
  if (telegramOverlay.classList) {
    telegramOverlay.classList.remove('active', 'visible', 'shown');
  }
}
